import { isPlatformBrowser } from '@angular/common'
import { HttpClient } from '@angular/common/http'
import { Injectable, PLATFORM_ID, inject } from '@angular/core'
import { NavigationEnd, Router } from '@angular/router'
import { environment } from '@environment/environment'
import { filter } from 'rxjs'

@Injectable({ providedIn: 'root' })
export class PageViewTrackingService {
    private http = inject(HttpClient)
    private router = inject(Router)
    private platformId = inject(PLATFORM_ID)
    private apiUrl = `${environment.serviceUrl}/track-event`

    init() {
        if (!isPlatformBrowser(this.platformId)) return

        this.router.events
            .pipe(filter((e): e is NavigationEnd => e instanceof NavigationEnd))
            .subscribe((event) => {
                const trackedEvent = {
                    eventType: 'page_view',
                    eventDetails: {
                        url: event.urlAfterRedirects,
                        referrer: document.referrer || null,
                    },
                    timestamp: new Date().toISOString(),
                }
                this.http.post(this.apiUrl, [trackedEvent]).subscribe({
                    error: () => {},
                })
            })
    }
}
